let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9271M")).then(() => parcelRequire('f0kiB'));